import { useState, useLayoutEffect } from 'react';
export const useBreakPoint = breakpoints => {
  const [width, setWidth] = useState(breakpoints?.desktop || 1056);
  const isDesktop = width >= (breakpoints?.desktop || 1056);
  const isTablet = !isDesktop && width >= (breakpoints?.tablet || 672);
  const isMobile = !isDesktop && !isTablet;
  useLayoutEffect(() => {
    function updateSize() {
      setWidth(document.body.clientWidth);
    }
    window.addEventListener('resize', updateSize);
    updateSize();
    return () => window.removeEventListener('resize', updateSize);
  }, []);
  return {
    width,
    isDesktop,
    isTablet,
    isMobile
  };
};